import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import Seo from "../components/Seo";
import api from "../lib/api";

export default function NewsletterDesinscription() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const email = params.get("email") || "";
  const token = params.get("token") || "";

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!email || !token) { setStatus("error"); return; }
    api.post("/newsletter/unsubscribe", { email, token })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [email, token]);

  return (
    <div className="min-h-screen bg-white" data-testid="newsletter-unsub-page">
      <Seo title="Désinscription à la newsletter | 360immoinvest" description="Gérez votre abonnement à la newsletter 360immoinvest." path="/newsletter/desinscription" />
      <Header />
      <main className="pt-36 pb-24">
        <div className="max-w-lg mx-auto px-5 lg:px-8 text-center">
          {status === "loading" && (
            <div className="flex flex-col items-center gap-4" data-testid="unsub-loading">
              <Loader2 className="w-10 h-10 text-brand-greenDeep animate-spin" />
              <p className="text-brand-green/70">Traitement de votre demande…</p>
            </div>
          )}
          {status === "done" && (
            <div className="flex flex-col items-center gap-4" data-testid="unsub-done">
              <CheckCircle2 className="w-14 h-14 text-emerald-600" />
              <h1 className="font-display text-3xl font-semibold text-brand-greenDeep">Vous êtes désinscrit</h1>
              <p className="text-brand-green/70">Vous ne recevrez plus notre newsletter. Vous pouvez vous réinscrire à tout moment depuis le blog.</p>
              <Link to="/blog" className="mt-2 inline-flex px-6 py-3 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold text-sm">Retour au blog</Link>
            </div>
          )}
          {status === "error" && (
            <div className="flex flex-col items-center gap-4" data-testid="unsub-error">
              <XCircle className="w-14 h-14 text-red-500" />
              <h1 className="font-display text-3xl font-semibold text-brand-greenDeep">Lien invalide</h1>
              <p className="text-brand-green/70">Ce lien de désinscription est invalide ou a expiré. Contactez-nous si vous souhaitez être retiré de notre liste.</p>
              <Link to="/" className="mt-2 inline-flex px-6 py-3 rounded-full border border-brand-soft hover:bg-brand-softer text-brand-greenDeep font-semibold text-sm">Accueil</Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
